module.exports = __webpack_public_path__ + "static/img/fc-bg.da0ac22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fc-bg.jpg
// module id = z5wL
// module chunks = 0